import React from "react";

const AccordionItem = ({ title, isOpen, onToggle, children }) => {
  return (
    <div className="bg-[#39699D] rounded-lg mb-2">
      <div
        className="flex justify-between items-center p-4 cursor-pointer"
        onClick={onToggle}
      >
        <p className="font-bold text-white">{title}</p>
        <svg
          className={`w-6 h-6 text-white transform transition-transform duration-300 ${
            isOpen ? "" : "rotate-180"
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M5 15l7-7 7 7"
          />
        </svg>
      </div>
      {isOpen && (
        <div className="p-4 bg-[#B8DAFF]">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionItem;
